export default "__VITE_ASSET__CEUKw84d__"